var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"giz-about-link link",attrs:{"tabindex":"0","role":"button"},on:{"click":function($event){return _vm.toggleModalAbout()},"keydown":function($event){return _vm.keyDown($event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }